import { TGuideList } from 'shared/types/guide';
import { EOfferType } from 'shared/types/wantType';

export const filterByType = (list: TGuideList[], activeType: EOfferType) => {
  return list.map(item => ({
    ...item,
    slider: item.slider.filter(slide => slide.type === activeType || slide.type === 'all'),
  }));
};
